import { ChildUser, Gender } from "@joonapp/web-shared"
import dayjs from "dayjs"
import { create } from "zustand"

interface EditChildProfileModalStore {
  isOpen: boolean
  onClose: () => void
  onOpen: (child: ChildUser) => void

  child: ChildUser | null
  setChild: (child: ChildUser) => void

  name: string
  setName: (name: string) => void

  birthdate: string | null
  setBirthdate: (birthdate: string | null) => void

  gender: Gender
  setGender: (gender: Gender) => void
}

const initialState = {
  isOpen: false,
  name: "",
  birthdate: "",
  gender: Gender.MALE,
  child: null,
}

const useEditChildProfileModalStore = create<EditChildProfileModalStore>(
  (set) => ({
    ...initialState,
    onClose: () => set(initialState),
    onOpen: (child) =>
      set({
        isOpen: true,
        name: child.name,
        birthdate: child.birthdate
          ? dayjs(child.birthdate).format("MM/DD/YYYY")
          : null,
        gender: child.gender ?? Gender.OTHER,
        child,
      }),
    setName: (name) => set({ name }),
    setBirthdate: (birthdate) => set({ birthdate }),
    setGender: (gender) => set({ gender }),
    setChild: (child) => set({ child }),
  })
)

export default useEditChildProfileModalStore
